import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CostProfile, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editCostProfile(data: Boundaries["editCostProfile"]["request"]): void;
}

function useEditCostProfile(costProfile: Identifiable<CostProfile>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditCostProfileRequestPending(costProfile),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditCostProfileRequestSuccess(costProfile),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditCostProfileRequestFailure(costProfile),
    ),
    editCostProfile: core.editCostProfile,
  };
}

export { useEditCostProfile };
